import { useTranslation } from 'react-i18next'

import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
// import Resolucion from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/components/Origen/components/Resolucion/Resolucion'
import OrganoOrigen from 'src/components/views/EscritosLexnet/components/IniciadorEjecucion/components/Origen/components/OrganoOrigen/OrganoOrigen'
import NIG from 'src/components/views/EscritosLexnet/components/shared/components/NIG/NIG'
import Procedimiento from 'src/components/views/EscritosLexnet/components/shared/components/Procedimiento/Procedimiento'

function Origen(): JSX.Element {
  const { t } = useTranslation()

  return (
    <FieldsetGroup legend={t('form.legend.origen')}>
      <OrganoOrigen />
      <Procedimiento />
      <NIG />
    </FieldsetGroup>
  )
}

export default Origen
